import { render, staticRenderFns } from "./LoadSapNew.vue?vue&type=template&id=b58a313c"
import script from "./LoadSapNew.vue?vue&type=script&lang=js"
export * from "./LoadSapNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports